import { FaPlus, FaMinus } from 'react-icons/fa';
import ImageWithToken from './ImageWithToken';
import ApiService from '../ApiService';

function PlaceCard({ user, place, handlePlaceCardClick, handleLocationIconClick, handleSelectIconClick, handleRemoveIconClick, selectedList, index, routeMode }) {
  const placeName = place.description?.name || 'Unknown Place';
  const placeCategory = place.types?.[0]?.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase()) || 'Place';
  const placeVicinity = place.description?.vicinity || 'Interesting place to visit';
  const isSelected = selectedList.has(place.reference);


  return (
    <div
      className={`place-card ${isSelected ? "selected" : ""}`}
      onClick={() => handlePlaceCardClick(place)}
    >
      <div className="card-image">
        <ImageWithToken imageUrl={ApiService.create_place_photo_url(place)} user={user} alt={placeName} />
        <div className="card-top-left">
          {isSelected && <div className="card-selection-number">{index + 1}</div>}
          <div className="card-category">{placeCategory}</div>
        </div>
        <div className="card-actions">
          {!routeMode && (<div className={`card-select`} onClick={(e) => {handleSelectIconClick(e, place)}}>
            {isSelected ? <FaMinus/> : <FaPlus />}
          </div>)}
          {/* <div className="card-location" onClick={(e) => handleLocationIconClick(e, place)}>
            <FaMapMarkerAlt />
          </div>
          <div className="card-location" onClick={(e) => handleRemoveIconClick(e, place)}>
            <FaTimes />
          </div> */}
        </div>
        <div className="card-info-overlay">
          <h3>{placeName}</h3>
          <p>{placeVicinity}</p>
        </div>
      </div>
    </div>
  );
}

export default PlaceCard;
